import { useState, useEffect } from 'react';

import { SCREENS } from '~/styles/extended-theme';

// Defaulted for below tablet sizes, but can be changed
export function useIsBelowBreakpoint(breakpoint: number = SCREENS.Tablet) {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const updateScreenSize = () => {
      setIsBelowBreakpoint(mediaQuery.matches);
    };

    updateScreenSize();

    mediaQuery.addEventListener('change', updateScreenSize);

    return () => {
      mediaQuery.removeEventListener('change', updateScreenSize);
    };
  }, [breakpoint]);

  return isBelowBreakpoint;
}
